import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { AnalyticsBaseChartComponent } from "app/analytics/component/analytics-base-chart/analytics-base-chart.component";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
  UserPermissions,
  ExpirationTimePeriod,
} from "app/shared";
import { UserSessionsConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "users-sessions-details",
  templateUrl: "./users-sessions-details.component.html",
  standalone: false,
})
export class UsersSessionsDetailsComponent
  extends BaseDetailsLogic<UserSessionsConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, UserSessionsConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedPermission(): number | UserPermissions {
    return this.config.userPermission as UserPermissions;
  }

  set selectedPermission(value: number | UserPermissions) {
    this.config.userPermission = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  public localSelectedChartType: string = "";

  protected override onConfigReady(): void {
    this.localSelectedChartType = this.config?.generalSettings?.chartType || "";
  }
  
  get sessionExpirationPeriod(): string | ExpirationTimePeriod {
    return this.config?.sessionExpirationPeriod as ExpirationTimePeriod;
  }

  set sessionExpirationPeriod(value: string | ExpirationTimePeriod) {
    this.config.sessionExpirationPeriod = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see user session data for that range. For example, you can look at sessions from the last week, month, or year. This helps you understand when people are using the application most.",
      userPermission:
        "Select the type of user permission to filter session results. You can choose to see sessions only for administrators, editors, or regular users. This helps you focus on the activity of specific user groups.",
      expirationTimePeriod:
        'Choose how long a session should last before it is considered expired. For example, if you select "30 minutes", any session that has not been active for 30 minutes will be considered ended. This helps you analyze active session patterns.',
      increments:
        "Shows the spacing between each point on the line chart's X-axis. For example, if increments are set to 'Hour', each point represents an hour. This helps you understand the time step between data points.",
    };
  }
}
